module.exports = __webpack_public_path__ + "img/iconRBIF.80268e49.svg";